import {
  getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodeClientAdminsBlobs201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 社内報ファイル Blob アップロードAPIを実行するカスタムフック。
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostBlob = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsBlobs201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsBlobsMutationFetcher(threeLetterCode),
    options
  );
};
